import { createRoute } from '@tanstack/react-router';
import { securedParentRoute } from 'pages/secured/securedParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const securedLabClaimRoute = createRoute({
  getParentRoute: () => securedParentRoute,
  path: '/claims/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    access_token: z.string().optional(),
  }),
}).lazy(() =>
  import('pages/secured/Claims/SecuredLabClaimPage/SecuredLabClaimPage').then((d) => d.Route)
);
